import { useTracker, useUBLContext, ZigzagEvent } from '@common/log-manager';
import { getUrl } from '@domains/pdp-common';

export const useDescriptionUBL = () => {
  const tracker = useTracker();
  const ublContext = useUBLContext();

  const clickDescToggleButtonUBL = (catalog_product_id: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_type: 'button',
      object_section: 'subtab_description',
      object_id: 'see_more',
      data: JSON.stringify({ catalog_product_id }),
    });

    tracker.addLog({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: 'subtab_description',
      object_type: 'button',
      object_id: 'see_more',
      data: { catalog_product_id },
    });
  };
  return { clickDescToggleButtonUBL };
};
